import { DATA_OCCUPATIONS } from "../data/options";

export const toOccupationOptions = (data) => {
  if (!Array.isArray(data) || data.length === 0) return DATA_OCCUPATIONS;
  return data.map((item) =>
    typeof item === "string"
      ? { value: item, label: item }
      : { value: item.value, label: String(item.label ?? item.value) }
  );
};

export const formatOccupationLabel = (value, options = DATA_OCCUPATIONS) => {
  if (value == null || value === "") return "";
  const match = options.find((item) => item.value === value);
  return match ? String(match.label).trim() : String(value);
};

export const resolveOccupationValue = (
  text,
  options = DATA_OCCUPATIONS,
  { trim = false } = {}
) => {
  const raw = text == null ? "" : String(text);
  const trimmed = raw.trim();
  if (!trimmed) return "";
  const match = options.find(
    (item) => String(item.label).trim() === trimmed || item.value === trimmed
  );
  if (match) return match.value;
  return trim ? trimmed : raw;
};
